import React, { useContext } from "react";
import { Link } from "react-router-dom";

// Icons
import { LogoutOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
// Utils
import { signOutUser } from "utils/firebase/authentication.firebase";
// Context
import { AuthContext } from "utils/context/authentication.context";

const LoginAndLogOut = () => {
  const { isAuthorized } = useContext(AuthContext);

  const handleUserSignOut = () => {
    signOutUser();
  };

  return (
    <Link to={"/therapist-auth/sign-in"} style={{ display: "flex", marginInline: { md: ".5rem" } }}>
      {isAuthorized && (
        <IconButton sx={{ padding: "0 !important" }} aria-label="Therapist sign-in" onClick={handleUserSignOut}>
          <LogoutOutlined sx={{ color: "#F77C3A", height: "26px", width: "26px" }} />
        </IconButton>
      )}
    </Link>
  );
};

export default LoginAndLogOut;
